import React from 'react';
import { Button } from 'primereact/button';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function CreateFolderButton() {
  const { modals } = useFileManagerContext();

  const handleCreateFolder = () => {
    modals.setShowCreateFolderModal(true);
  };

  return <Button label="Create Folder" className="p-button p-button-primary text-nowrap" onClick={handleCreateFolder} />;
}

export default CreateFolderButton;
